'use strict';

//import angular from 'angular';

export default function ($uibModalInstance, sgcontenteditorService) {
  'ngInject';
  var self = this;

  self.elementlist = [
    {
      name: 'DH Header',
      description: 'Header with place for page banner image',
      elementDefaults: {
        type: 'dhheader',
        data: {
          img: ''
        }
      }
    },
    {
      name: 'Columns',
      description: 'Full Width Columns',
      elementDefaults: {
        type: 'columns',
        children: [
          { type: 'column', children: [] }
        ],
        data: {
          contain: false
        }
      }
    },
    {
      name: 'Section',
      description: 'Full Width Section',
      elementDefaults: {
        type: 'section',
        data: {
          contain: true
        }
      }
    },
    {
      name: 'HTML Text',
      description: 'Standard HTML Text that can be formatted and include images',
      elementDefaults: { type: 'html', data: { text: 'New HTML Element' } }
    },
    {
      name: 'Logos',
      description: 'Display Testimonial Company Logos',
      elementDefaults: {
        type: 'logos'
      }
    },
    {
      name: 'Down Arrow',
      description: 'Down Arrow to Divide Sections',
      elementDefaults: {
        type: 'downarrow'
      }
    },
    {
      name: 'Number Spinner',
      description: 'Tweens between numbers',
      elementDefaults: {
        type: 'numberSpinner',
        data: { start: 0, end: 100, duration: 2000, delay: 0, easing: 'linear'}
      }
    }, {
      name: 'Tweets',
      description: 'Shows tweets from a user and optional hashtag',
      elementDefaults: {
        type: 'tweets'
      }
      }, {
          name: 'News Page',
          description: '',
          elementDefaults: {
              type: 'newsPage'
          }
      }, {
          name: 'News Homepage Footer',
          description: '',
          elementDefaults: {
              type: 'newsHomefoot'
          }
      }, {
          name: 'News Homepage Spotlight',
          description: '',
          elementDefaults: {
              type: 'newsHomespotlight'
          }
    }, {
      name: 'Testimonial Circle Feature',
      description: 'Shows testimonials with the logo in a circle',
      elementDefaults: {
        type: 'testimonialcirclefeature'
      }
    }, {
      name: 'Testimonial Image Feature',
      description: 'Shows company image with optional testimoinal',
      elementDefaults: {
        type: 'testimonialimagefeature'
      }
    }, {
      name: 'Testimonial Feature',
      description: 'Shows testimonials with the logo (Original for Results Page)',
      elementDefaults: {
        type: 'resultsfeature'
      }
    }, {
      name: 'Testimonial Letters',
      description: 'Shows testimonials letters',
      elementDefaults: {
        type: 'letters'
      }
    }, {
      name: 'Programs Page Boxes',
      description: '',
      elementDefaults: {
        type: 'programsboxes'
      }
    }, {
      name: 'Event Call to Action',
      description: '',
      elementDefaults: {
        type: 'eventcalltoaction'
      }
    }, {
      name: 'Image Feature',
      description: '',
      elementDefaults: {
        type: 'imagefeature',
        data: { images: [] }
      }
    }, {
      name: 'Grouped Tabs (Unpopulated)',
      description: 'sgcontenteditor Tabs with Sub Groups',
      elementDefaults: {
        type: 'groupedtabs',
        children: [
          {
            type: 'tab',
            data: { name: 'Tab 1', description: 'Description 1' },
            children: [{ type: 'subtab', data: { name: 'Sub Tab 1-1', teacheronly: false }, children: [] }]
          },
          {
            type: 'tab',
            data: { name: 'Tab 2', description: 'Description 2' },
            children: [{ type: 'subtab', data: { name: 'Sub Tab 2-1', teacheronly: false }, children: [] }]
          },
          {
            type: 'tab',
            data: { name: 'Tab 3', description: 'Description 3' },
            children: [{ type: 'subtab', data: { name: 'Sub Tab 3-1', teacheronly: false }, children: [] }]
          },
          {
            type: 'tab',
            data: { name: 'Tab 4', description: 'Description 4' },
            children: [{ type: 'subtab', data: { name: 'Sub Tab 4-1', teacheronly: false }, children: [] }]
          }
        ]
      }
    },
    {
      name: 'Video',
      description: '',
      elementDefaults: { type: 'video', data: { aspectratio: '16by9' } }
    },
    {
      name: 'Popup',
      description: 'Popup with Elements',
      elementDefaults: {
        type: 'popuphtml',
        children: [
          { type: 'html', data: { text: "New HTML Element" } }
        ]
      }
    },
    {
      name: 'iFrame',
      description: '',
      elementDefaults: {
        type: 'iframe',
        data: {
          url: ''
        }
      }
    },
  ];

  self.ElementSelected = function ElementSelected(elementitem) {
    var element = angular.copy(elementitem.elementDefaults);
    element.element_id = sgcontenteditorService.generateUUID();
    $uibModalInstance.close(element);
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/sgcontenteditorAdmin/popups/elementList.js